import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { AthleteKiloClassManualCredit, AthleteKiloClassWithCredit, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

type ManualCreditAthleteClassVars = {
  athleteKiloClassId: string;
  manualCredit: AthleteKiloClassManualCredit;
};

export default function useManualCreditAthleteClass(): UseMutationResult<
  AxiosResponse<AthleteKiloClassWithCredit>,
  AxiosError<ErrorMessage>,
  ManualCreditAthleteClassVars
> {
  const queryClient = useQueryClient();

  const manualCreditAthleteClass = ({
    athleteKiloClassId,
    manualCredit,
  }: ManualCreditAthleteClassVars): Promise<AxiosResponse<AthleteKiloClassWithCredit>> => {
    return client.put(`athlete-kilo-classes/${athleteKiloClassId}/credit/`, manualCredit);
  };

  return useMutation(manualCreditAthleteClass, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athleteClasses'],
      });
      queryClient.invalidateQueries({
        queryKey: ['athleteEvents'],
      });
      queryClient.invalidateQueries({
        queryKey: ['classes'],
      });
      queryClient.invalidateQueries({
        queryKey: 'events',
      });
      queryClient.invalidateQueries({
        queryKey: ['totalAttended'],
      });
      queryClient.invalidateQueries({
        queryKey: ['totalReserved'],
      });
    },
  });
}
